<template>
  <div class="container">

    <heading-one class="-margin-md">入力内容のご確認</heading-one>

    <errors-alert :errors="errors"></errors-alert>

    <wizard-group class="_mb-sm-35 _mb-md-50">
      <main-wizard :active-index="1" type="entry"></main-wizard>
    </wizard-group>

    <p>ご入力内容をご確認のうえ、最下部にある「口座のご登録へ進む」ボタンを押して、お申し込み手続きを進めてください。</p>
    <p class="important">氏名（漢字、フリガナ）など誤りが無いか、必ずご確認ください。</p>

      <section>
      <heading-two>お客さま情報</heading-two>
      <table-group>
        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">氏名 <small>（漢字）</small>
              </table-header>
              <table-data>
                {{displayNameKanji}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">氏名 <small>（フリガナ）</small>
              </table-header>
              <table-data>
                {{displayNameKana}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                生年月日
              </table-header>
              <table-data>
                <label>{{displayBth}}</label>
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                性別
              </table-header>
              <table-data>
                {{displaySex}}
              </table-data>
            </table-row>
            <table-row v-if="showAuPhone">
              <table-header class="-entry">au携帯電話番号または<br>UQ mobile 電話番号
              </table-header>
              <table-data>
                {{displayPhoneAu}}
              </table-data>
            </table-row>
            <table-row v-if="!showAuPhone">
              <table-header class="-entry">電話番号<small>（その他）</small>
              </table-header>
              <table-data>
                {{displayPhoneMobile}}
              </table-data>
            </table-row>
            <template v-if="showDefaultMail">
              <table-row>
                <table-header class="-entry" rowspan="3">メールアドレス
                </table-header>
                <table-data>
                  {{displayEzMail}}
                </table-data>
              </table-row>
              <table-row>
                <table-data>
                  {{displayMail1}}
                </table-data>
              </table-row>
              <table-row>
                <table-data>
                  {{displayMail2}}
                </table-data>
              </table-row>
            </template>
            <table-row v-if="showLoanMail">
              <table-header class="-entry">メールアドレス
              </table-header>
              <table-data>
                {{userData.loan_mail}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry" >キャンペーンメール受信
              </table-header>
              <table-data>
                {{displayMailNotice}}
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">暗証番号
              </table-header>
              <table-data>****
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">
                運転免許証の有無
              </table-header>
              <table-data>
                {{displayDriverLicenseFlg}}
              </table-data>
            </table-row>
            <table-row v-if="showDriverLicenseNum">
              <table-header class="-entry">
                運転免許証番号
              </table-header>
              <table-data>
                {{userData.driver_license_num}}
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <heading-two class="_mt-sm-60">ご自宅情報</heading-two>
        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">
                郵便番号
              </table-header>
              <table-data>
                〒{{displayPostcode}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                ご住所 <small>（漢字）</small>
              </table-header>
              <table-data>
                {{displayAddress}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                ご住所 <small>（フリガナ）</small>
              </table-header>
              <table-data>
                {{userData.address_kana}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                お住まいの種類
              </table-header>
              <table-data>
                {{displayHomeType}}
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">
                居住年数
              </table-header>
              <table-data>
                {{displayJkyNgt}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                住宅ローンあるいは家賃のお支払い<small>（月額）</small>
              </table-header>
              <table-data>
                {{displayRentLoanAmount}}
              </table-data>
            </table-row> <!-- row -->
          </table-body> <!-- table-body -->
        </table-box>

        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">
                ご家族<small>（配偶者さま）</small>
              </table-header>
              <table-data>
                {{displayMarriageStatus}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                ご家族<small>（お子さま）</small>
              </table-header>
              <table-data>
                {{displayNumberOfChildren}}
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <btngroup-single class="-marginbottom">
          <btn-back class="-back -md" routerName="en002" tracking-name="en005_edit_button_1">
            修正する
          </btn-back>
        </btngroup-single>

        <heading-two class="_mt-sm-60">お勤め先情報</heading-two>
        <table-box class="-entry">
          <table-body>
            <table-row>
              <table-header class="-entry">
                職業
              </table-header>
              <table-data>
                {{displayWorkForm}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                業種
              </table-header>
              <table-data>
                {{displayBizType}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                職種
              </table-header>
              <table-data>
                {{displayJobType}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                お勤め先
              </table-header>
              <table-data>
                {{userData.office_nm}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                お勤め先電話番号
              </table-header>
              <table-data>
                {{displayOfficePhone}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                所属部署
              </table-header>
              <table-data>
                {{userData.office_depart}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                入社年月
              </table-header>
              <table-data>
                {{displayNshNgt}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                社員数
              </table-header>
              <table-data>
                {{displayStaffNum}}
              </table-data>
            </table-row>
            <table-row>
              <table-header class="-entry">
                年収 <small>（税込）</small>
              </table-header>
              <table-data>
                {{displayGrossSalary}}
              </table-data>
            </table-row>
          </table-body> <!-- table-body -->
        </table-box>

        <btngroup-single class="-marginbottom">
          <btn-back class="-back -md" routerName="en003" tracking-name="en005_edit_button_2">
            修正する
          </btn-back>
        </btngroup-single>

        <heading-two class="_mt-sm-60">他社のお借り入れ状況</heading-two>
          <table-box class="-entry">
            <table-body>
              <table-row>
                <table-header class="-entry">
                  他社の<br class="-spnone">お借り入れ状況 <small>（件数）</small>
                </table-header>
                <table-data>
                  {{displayotherLoanCount}}
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-entry">
                  他社の<br class="-spnone">お借り入れ状況 <small>（金額）</small>
                </table-header>
                <table-data>
                  {{displayOtherLoanAmount}}
                </table-data>
              </table-row>
            </table-body> <!-- table-body -->
          </table-box>

          <table-box class="-entry">
            <table-body>
              <table-row>
                <table-header class="-entry">
                  ご希望のご利用限度額
                </table-header>
                <table-data>
                  {{displayAskingLoanAmount}}
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-entry">
                  毎月のご返済日
                </table-header>
                <table-data>
                  {{displayRepaymentDate}}
                </table-data>
              </table-row>
            </table-body> <!-- table-body -->
          </table-box>

          <table-box class="-entry">
            <table-body>
              <table-row>
                <table-header class="-entry">
                  お取引の目的
                </table-header>
                <table-data>
                  <input-label>本サービスは生計費融資となり、事業費融資を目的としたお申し込みはお受けできません。</input-label>
                  {{userData.purpose_of_use}}
                </table-data>
              </table-row>
            </table-body> <!-- table-body -->
          </table-box>

          <btngroup-single class="_mb-sm-40">
            <btn-back class="-back -md" routerName="en004" tracking-name="en005_edit_button_3">
              修正する
            </btn-back>
          </btngroup-single>

        <form @submit.prevent="submitProfile" novalidate>
          <btngroup-single class="-margin-lg">
            <btn-main class="-main -lg confirmation" @click.prevent="submitProfile" tracking-name="en005_next_button" onmousedown="dlpoloan_moushikomiuketsukeClickCv()">
              入力を完了して、<br class="-pcnone">「口座のご登録」へ進む
            </btn-main>
            <p class="btn-txt"><span class="important">まだお申し込み手続きは完了しておりません。</span><br>ご入力内容をご確認のうえ、上記「口座のご登録」へ進むボタンを押して、お申し込み手続きを進めてください。</p>
          </btngroup-single>
        </form>
      </table-group>
    </section>

  </div>
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataLambdaInvoke, submitAttributesLambdaInvoke } from '../utils/LambdaHelper'
import { driverLicenseFlgs, askingLoanAmounts } from '../constants/constant'
import userData from '../components/mixin/UserData'
import { setTrackingEventDataSetting } from '../utils/TrackingDataHelper'

import HeadingOne from '../components/heading/HeadingOne'
import errorsAlert from '../components/alert/ErrorsAlert'
import InputError from '../components/input/InputError'
import TooltipsItem from '../components/tooltip/TooltipsItem'
import BtnTooltip from '../components/button/BtnTooltip'
import BtnMain from '../components/button/BtnMain'
import BtnInput from '../components/button/BtnInput'
import BtnBack from '../components/button/BtnBack'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtngroupDouble from '../components/button/BtngroupDouble'
import HeadingTwo from '../components/heading/HeadingTwo'
import BtnRadio from '../components/button/BtnRadio'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import BadgeIcon from '../components/badges/BadgeIcon'
import InputItem from '../components/input/InputItem'
import InputGroup from '../components/input/InputGroup'
import InputgroupAppend from '../components/input/InputgroupAppend'
import InputAppend from '../components/input/InputAppend'
import InputLabel from '../components/input/InputLabel'
import BtngroupRadio from '../components/button/BtngroupRadio'
import MainWizard from '../components/wizard/MainWizard'
import WizardGroup from '../components/wizard/WizardGroup'
import TableGroup from '../components/tables/TableGroup'

export default {
  name: 'En-005',
  metaInfo: {
    title: '入力内容のご確認',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,お借り入れ状況'}
    ]
  },
  mixins: [userData],
  components: {
    TableGroup,
    WizardGroup,
    MainWizard,
    HeadingTwo,
    BtngroupSingle,
    BtngroupDouble,
    BtnTooltip,
    TooltipsItem,
    errorsAlert,
    InputError,
    HeadingOne,
    BtnMain,
    BtnBack,
    BtnInput,
    InputLabel,
    InputAppend,
    InputgroupAppend,
    InputGroup,
    InputItem,
    BadgeIcon,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtnRadio,
    BtngroupRadio
  },
  data () {
    return {
      errors: null,
      isDisabled: false,
      userData: {
        // お客さま情報
        lastname_kanji: '',
        firstname_kanji: '',
        lastname_kana: '',
        firstname_kana: '',
        bth: '',
        sex: '',
        phone_au_1: '',
        phone_au_2: '',
        phone_au_3: '',
        phone_mobile_1: '',
        phone_mobile_2: '',
        phone_mobile_3: '',
        ez_mail: '',
        mail_1: '',
        mail_2: '',
        loan_mail: '',
        notice_flg: '',
        driver_license_flg: '',
        driver_license_num: '',
        // ご自宅情報
        postcode: '',
        address_region: '',
        address_city: '',
        address_street: '',
        address_building: '',
        address_kana: '',
        home_type: '',
        nky_ngt: '',
        rent_loan_amount: '',
        marriage_status: '',
        number_of_children: '',
        // お勤め先情報
        work_form: '',
        biz_type: '',
        job_type: '',
        office_nm: '',
        office_phone_1: '',
        office_phone_2: '',
        office_phone_3: '',
        office_depart: '',
        nsh_ngt: '',
        staff_num: '',
        gross_salary: '',
        // 他社のお借り入れ状況
        other_loan_count: '',
        other_loan_amount: '',
        asking_loan_amount: '',
        repayment_date: '', // 26日固定
        purpose_of_use: ''
      }
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
        this.$store.dispatch('setSystemAuId', res.system_auid)
      }).catch(error => {
        this.goToErrorPage(error)
      })
      setTrackingEventDataSetting()
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  computed: {
    showAuPhone () {
      return this.userData.phone_au_1 && this.userData.phone_au_2 && this.userData.phone_au_3
    },
    showLoanMail () {
      return !this.userData.ez_mail && !this.userData.mail_1 && !this.userData.mail_2
    },
    showDefaultMail () {
      return !this.showLoanMail
    },
    displayMailNotice () {
      return this.userData.notice_flg ? '同意する' : '同意しない'
    },
    displayDriverLicenseFlg () {
      for (let driverLicenseFlg of driverLicenseFlgs) {
        if (driverLicenseFlg.value === this.userData.driver_license_flg) {
          return driverLicenseFlg.name.replace('<br>', '')
        }
      }
      return ''
    },
    showDriverLicenseNum () {
      return this.userData.driver_license_flg === '1'
    },
    displayotherLoanCount () {
      return this.userData.other_loan_count + '件'
    },
    displayOtherLoanAmount () {
      return parseInt(this.userData.other_loan_amount / 10000) + '万円'
    },
    displayAskingLoanAmount () {
      for (let askingLoanAmount of askingLoanAmounts) {
        if (askingLoanAmount.value === this.userData.asking_loan_amount) {
          return askingLoanAmount.name
        }
      }
      return ''
    }
  },
  methods: {
    submitProfile: function (event) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      initCredentials().then(res => {
        submitAttributesLambdaInvoke().then(res => {
          this.errors = res.errors || {}
          if (Object.keys(this.errors).length > 0) {
            this.scrollTop()
            this.isDisabled = false
          } else {
            let response = JSON.parse(res.body)
            // statusが3の場合は入会資格なしページへ遷移させる
            if (response.status === '3') {
              this.$router.push({name: 'en023'})
            } else {
              this.$router.push({name: 'en006', query: {state: '0'}})
            }
          }
        }).catch(error => {
          this.goToErrorPage(error)
        })
      }).catch(error => {
        this.goToErrorPage(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";

.important {
  color: $danger;
}

.btn-txt {
  @include mq-down(md) {
    margin-top: 15px;
    margin-bottom: 35px;
  }
  @include mq-up(md) {
    margin-top: 15px;
    margin-bottom: 60px;
  }
}

.btn-main.-lg.confirmation {
  @include mq-down(md) {
    border-radius: 32px;
    width: 380px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/En005.vue